import React, { useEffect, useState } from 'react';
import {
  isConfigSettled,
  isProduction,
  useConfigSelection,
  getModulePath,
  LEAGUE_MODULE_NAMES,
} from '@leagueplatform/core';
import { Routes, Route, useNavigate, useParams } from '@leagueplatform/routing';
import { useFeatureFlagQuery } from '@leagueplatform/user-profile-api';
import { HealthProgramsPage } from '#pages/main/health-programs-page.component.jsx';
import { HealthProgramDetails } from '#pages/program-details/health-program-details.component.jsx';
import { HealthProgramsCategoryPage } from '#pages/category/health-programs-category-page.component.jsx';
import { ENABLE_CHALLENGES_WELLNESS_AND_REWARDS } from '@leagueplatform/health-journey-common';
import { AllChallengesByType } from '#pages/all-challenges/all-challenges-by-type.component.tsx';

// redirect to masonry powered program overview page when legacy details page is deprecated

function ProgramOverviewRedirect() {
  const navigate = useNavigate();

  const { programId } = useParams();

  useEffect(() => {
    navigate(`${getModulePath(LEAGUE_MODULE_NAMES.program)}?id=${programId}`, {
      replace: true,
    });
  }, [navigate, programId]);

  return null;
}

function useEnableProgramOverviewMasonry() {
  const [isLocallyEnabled, setIsLocallyEnabled] = useState(false);
  const defaultServerConfig = {
    enableMasonry2ForCampaignOverview: false,
  };

  useEffect(() => {
    const value = localStorage.getItem('enableProgramOverviewMasonry2');
    setIsLocallyEnabled(value === 'true');
  }, []);

  const serverDrivenConfig = useConfigSelection(
    (config) =>
      isConfigSettled(config)
        ? {
            enableMasonry2ForCampaignOverview:
              config.config
                .release_journey_experience_masonry_2_for_campaign_overview,
          }
        : {},
    defaultServerConfig,
  );

  return (
    serverDrivenConfig.enableMasonry2ForCampaignOverview ||
    (isLocallyEnabled && !isProduction())
  );
}

// TODO: rename as HealthProgramsSubroutes
export const HealthProgramsRoutes = () => {
  const { data: isChallengesWellnessAndRewardsEnabled } = useFeatureFlagQuery(
    ENABLE_CHALLENGES_WELLNESS_AND_REWARDS,
  );
  const isMasonryCampaignOverviewEnabled = useEnableProgramOverviewMasonry();

  return (
    <Routes>
      <Route
        path="category/:categoryId/*"
        element={<HealthProgramsCategoryPage />}
      />
      {isChallengesWellnessAndRewardsEnabled && (
        <Route path="all-challenges" element={<AllChallengesByType />} />
      )}
      <Route
        path=":programId"
        element={
          isMasonryCampaignOverviewEnabled ? (
            <ProgramOverviewRedirect />
          ) : (
            <HealthProgramDetails />
          )
        }
      />
      {/*
          If the new configurable journey experience is not enabled for the user (e.g. isConfigurableJourneyExperience is a falsy value)
          we fall back to rendering the old health programs page when we reach the /health-programs route. See capabilities/health-journey/src/health-journey-routes.tsx
          for more details.

          This route should be deleted when we deprecate the old Journey Experience
      */}
      <Route element={<HealthProgramsPage />} path="/*" />
    </Routes>
  );
};
